import { render, staticRenderFns } from "./dashboard-documents.vue?vue&type=template&id=30f0a046"
import script from "./dashboard-documents.vue?vue&type=script&lang=js"
export * from "./dashboard-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports